const globalState = {
    state: {
      listFileFolderOrganizeSelectedOption: "On top",
      theme: "light",
      language: "en",
      isSidebarOpen: true,
      filters: {
        type: null,
        people: null,
        modified: null,
        source: null,
      },
    },
  
    
    listeners: new Set(),
  
    getState(key) {
      return this.state[key];
    },
  
    setState(key, value) {
      if (this.state.hasOwnProperty(key)) {
        this.state[key] = value;
        this.listeners.forEach((listener) => listener({ key, value }));
      }
    },
    resetState() {
        this.state = JSON.parse(JSON.stringify(this.defaultState)); // Deep copy to reset state
        this.listeners.forEach((listener) => listener({ key: "reset", value: this.state }));
      },
  
    resetFilters() {
      this.state.filters = {
        type: null,
        people: null,
        modified: null,
        source: null,
      };
      this.listeners.forEach((listener) => listener({ key: "filters", value: this.state.filters }));
    },
  
    subscribe(listener) {
      this.listeners.add(listener);
      return () => this.listeners.delete(listener);
    },
  };
  
  export default globalState;
  